import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getFacilityByUserId as _getFacilityByUserId,
  getAllFacilities as _getAllFacilities,
  connectFacilityAndCaregiver,
  connectFacilityAndPatient,
  disconnectFacilityAndCaregiver,
  disconnectFacilityAndPatient,
  connectFacilityAndAdmin,
  disconnectFacilityAndAdmin,
} from 'api/controllers/facility-controller';
import { UserRole } from 'types/enums';

import { UserRoleType, type AsyncThunkConfig, type FacilityResponseDto } from 'types/types';
import { facilityActions } from '.';

export const leaveFacility = createAsyncThunk<void, string, AsyncThunkConfig>(
  'facility/leaveFacility',
  async (id, { getState, dispatch }) => {
    const { user } = getState();
    if (!user || typeof user.data?.role !== 'number') {
      return null;
    }

    const role = user.data.role as UserRoleType;
    if (role === UserRole.PATIENT && user.data.patientId) {
      await disconnectFacilityAndPatient({ facilityId: id, patientId: user.data.patientId });
    }
    if (role === UserRole.CAREGIVER && user.data.caregiverId) {
      await disconnectFacilityAndCaregiver({ facilityId: id, caregiverId: user.data.caregiverId });
    }

    if (role === UserRole.ADMIN && user.data.adminId) {
      await disconnectFacilityAndAdmin({ facilityId: id, adminId: user.data.adminId });
    }

    dispatch(facilityActions.getAllFacilities());
    dispatch(facilityActions.getFacilityByUserId(user.data?.id));

    return null;
  },
);

const connectToFacility = createAsyncThunk<void, string, AsyncThunkConfig>(
  'facility/connectToFacility',
  async (id, { getState, dispatch }) => {
    const { user } = getState();
    if (!user || typeof user.data?.role !== 'number') {
      return null;
    }

    const role = user.data.role as UserRoleType;
    if (role === UserRole.PATIENT && user.data.patientId) {
      await connectFacilityAndPatient({ facilityId: id, patientId: user.data.patientId });
    }
    if (role === UserRole.CAREGIVER && user.data.caregiverId) {
      await connectFacilityAndCaregiver({ facilityId: id, caregiverId: user.data.caregiverId });
    }

    if (role === UserRole.ADMIN && user.data.adminId) {
      await connectFacilityAndAdmin({ facilityId: id, adminId: user.data.adminId });
    }

    dispatch(facilityActions.getAllFacilities());
    dispatch(facilityActions.getFacilityByUserId(user.data?.id));

    return null;
  },
);

const getFacilityByUserId = createAsyncThunk<FacilityResponseDto[], string>(
  'facility/getFacilityByUserId',
  async (id) => {
    try {
      return await _getFacilityByUserId(id);
    } catch (err) {
      console.error(err, 'error in facility/getFacilityByUserId action');

      return null;
    }
  },
);

const getAllFacilities = createAsyncThunk<FacilityResponseDto[]>('facility/getAllFacilities', async () => {
  return await _getAllFacilities();
});

export { getFacilityByUserId, getAllFacilities, connectToFacility };
